const Header = ({ children }) => {
  return <>{children} </>;
};

Header.displayName = "PageHeader";

export default Header;
